module.exports = __webpack_public_path__ + "img/printer_square.1c3e99ee.png";